
<template>
  <div class="knowledge_query">
    <RadioGroup size="large" v-model="activeBtn" type="button" class="margin-bottom-20">
      <Radio label="bill">账单列表</Radio>
      <Radio label="gather">费用收取</Radio>
      <Radio label="payment">合同缴费</Radio>
    </RadioGroup>
    <Card>
      <cost-bill v-if="activeBtn=='bill'"></cost-bill>
      <cost-gather v-if="activeBtn=='gather'"></cost-gather>
      <contract-pay v-if="activeBtn=='payment'"></contract-pay>
    </Card>
  </div>
</template>
<script>
  import costBill from "./components/cost-bill.vue";
  import costGather from "./components/cost-gather.vue";
  import contractPay from "./components/contract-pay.vue";
  export default {
    name:'costMain_page',
    data() {
      return{
        activeBtn:'bill'
      }
    },
    components: {
      costBill,
      costGather,
      contractPay
    },
    methods:{

    }
  }
</script>
<style scoped>
  h4{ font-weight: normal; }
  .btn-group {
    padding-left: 20px;
  }
</style>






